import styled from 'styled-components';

export const CollectionPreviewContainer = styled.div`
   margin-bottom: 50px;
`;

export const TitleContainer = styled.h1`
  font-size: 28px;
  margin-bottom: 25px;
  cursor: pointer;
  &:hover {
    color: grey;
  }
`;

export const PreviewContainer = styled.div`
  display: flex;
   flex-wrap: wrap;
  justify-content: space-between;
`;